/// <amd-module name="VSS/Features/Search/SearchInput" />
export * from "./SearchInput/SearchInput";
export { ISearchInputComponentProps, ISearchInputComponentState } from "./SearchInput/SearchInput.Props";
